<div class="modal fade" tabindex="-1" [id]="modalId"> </div>

<nz-modal
    [(nzVisible)]="isVisible"
    [nzTitle]="modalTitle"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="save()"
    [nzOkLoading]="isConfirmLoading"
    [nzOkDisabled]="form.invalid"
    [nzCancelDisabled]="isConfirmLoading"
    [nzMaskClosable]="!isConfirmLoading"
    [nzKeyboard]="!isConfirmLoading"
    [nzClosable]="!isConfirmLoading"
    nzOkText="Save"
    nzCancelText="Cancel"
    [nzWidth]="650"
    [nzFooter]="modalFooter"> 
    
    <ng-container *nzModalContent>
        @if (!canEdit) {
            <app-unauthorized-access-edit-warning></app-unauthorized-access-edit-warning>
        }
        <form nz-form [formGroup]="form" [nzLayout]="'horizontal'">

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Category</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Category is required">
                    <nz-select formControlName="category" nzPlaceHolder="Select Category" [compareWith]="compareFn">
                        @for (c of categories; track c) {
                            <nz-option [nzValue]="c" [nzLabel]="c.name ?? ''"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Vendor</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Vendor is required">
                    <nz-select formControlName="vendor" nzPlaceHolder="Select Vendor" [compareWith]="compareFn">
                        @for (v of vendors; track v) {
                            <nz-option [nzValue]="v" [nzLabel]="v.name ?? ''"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            
            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Name</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Name is required (2-50 chars)">                    
                    <input nz-input formControlName="name" placeholder="Name" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">Description</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Description length: 2-100 chars">                    
                    <textarea nz-input formControlName="description" placeholder="Description" rows="3"></textarea>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Platforms</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="At least one platform is required">
                    <nz-select formControlName="platforms" nzPlaceHolder="Select Platforms" nzMode="multiple">
                        @for (p of platforms; track p) {
                            <nz-option [nzValue]="p" [nzLabel]="p ?? ''"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">Source Files</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                    @for (ctrl of srcControls.controls; track ctrl; let i = $index) {
                        <div style="margin-bottom: 12px;">
                            <app-drive-file-card
                                [canEdit]="canEdit"
                                [fileId]="ctrl.value.driveFileId"
                                [folderId]="ctrl.value.driveFolderId"
                                [fileName]="ctrl.value.driveFileName"
                                [fileLink]="ctrl.value.driveFileLink"
                                [showMetadata]="true"
                                [showRemove]="true"
                                iconType="file-zip"
                                iconColor="#1890ff"
                                (browse)="openDrivePicker(assetType.Src, i)"
                                (remove)="removeAsset(assetType.Src, i)">
                            </app-drive-file-card>
                        </div>
                    }
                    @if (canEdit) {
                        <button nz-button nzType="dashed" nzBlock (click)="openDrivePicker(assetType.Src)" type="button">
                            <span nz-icon nzType="plus"></span> Add Source File
                        </button>
                    } @else if (srcControls.controls.length === 0) {
                        <span class="text-muted">No files configured</span>
                    }
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">Libraries</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                    @for (ctrl of libControls.controls; track ctrl; let i = $index) {
                        <div style="margin-bottom: 12px;">
                            <app-drive-file-card
                                [canEdit]="canEdit"
                                [fileId]="ctrl.value.driveFileId"
                                [folderId]="ctrl.value.driveFolderId"
                                [fileName]="ctrl.value.driveFileName"
                                [fileLink]="ctrl.value.driveFileLink"
                                [showMetadata]="true"
                                [showRemove]="true"
                                iconType="file-text"
                                iconColor="#1890ff"
                                (browse)="openDrivePicker(assetType.Lib, i)"
                                (remove)="removeAsset(assetType.Lib, i)">
                            </app-drive-file-card>
                        </div>
                    }
                    @if (canEdit) {
                        <button nz-button nzType="dashed" nzBlock (click)="openDrivePicker(assetType.Lib)" type="button">
                            <span nz-icon nzType="plus"></span> Add Library File
                        </button>
                    } @else if (libControls.controls.length === 0) {
                        <span class="text-muted">No files configured</span>
                    }
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">Demos</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                    @for (ctrl of demoControls.controls; track ctrl; let i = $index) {
                        <div style="margin-bottom: 12px;">
                            <app-drive-file-card
                                [canEdit]="canEdit"
                                [fileId]="ctrl.value.driveFileId"
                                [folderId]="ctrl.value.driveFolderId"
                                [fileName]="ctrl.value.driveFileName"
                                [fileLink]="ctrl.value.driveFileLink"
                                [showMetadata]="true"
                                [showRemove]="true"
                                iconType="play-square"
                                iconColor="#faad14"
                                (browse)="openDrivePicker(assetType.Demo, i)"
                                (remove)="removeAsset(assetType.Demo, i)">
                            </app-drive-file-card>
                        </div>
                    }
                    @if (canEdit) {
                        <button nz-button nzType="dashed" nzBlock (click)="openDrivePicker(assetType.Demo)" type="button">
                            <span nz-icon nzType="plus"></span> Add Demo File
                        </button>
                    } @else if (demoControls.controls.length === 0) {
                        <span class="text-muted">No files configured</span>
                    }
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">Documentation</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                    @for (ctrl of docControls.controls; track ctrl; let i = $index) {
                        <div style="margin-bottom: 12px;">
                            <app-drive-file-card
                                [canEdit]="canEdit"
                                [fileId]="ctrl.value.driveFileId"
                                [folderId]="ctrl.value.driveFolderId"
                                [fileName]="ctrl.value.driveFileName"
                                [fileLink]="ctrl.value.driveFileLink"
                                [showMetadata]="true"
                                [showRemove]="true"
                                iconType="book"
                                iconColor="#52c41a"
                                (browse)="openDrivePicker(assetType.Documentation, i)"
                                (remove)="removeAsset(assetType.Documentation, i)">
                            </app-drive-file-card>
                        </div>
                    }
                    @if (canEdit) {
                        <button nz-button nzType="dashed" nzBlock (click)="openDrivePicker(assetType.Documentation)" type="button">
                            <span nz-icon nzType="plus"></span> Add Documentation File
                        </button>
                    } @else if (docControls.controls.length === 0) {
                        <span class="text-muted">No files configured</span>
                    }
                </nz-form-control>
            </nz-form-item>

        </form>
    </ng-container>

    <ng-template #modalFooter>
        <button nz-button nzType="default" (click)="handleCancel()">Close</button>
        @if (canEdit) {
            <button nz-button nzType="primary" [nzLoading]="isConfirmLoading" (click)="save()">Save</button>
        }
    </ng-template>

</nz-modal>

<app-drive-file-picker-modal (fileSelected)="onDriveFileSelected($event)"></app-drive-file-picker-modal>